export default __webpack_public_path__ + "6810c758918bf7082fa5a50cde17e6df.svg";